import React from 'react';
import type { TFunction } from 'i18next';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetEmailConfigDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { EmailConfigTypeObj } from '../../../common/pokCore/validation/enums';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { teamName } from '../../../utils/teamName';

interface EmailConfigSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
}

export const emailConfigForGrid = (
  t: TFunction<'administrationLng', 'administrationLng'>,
  emailConfig: GetEmailConfigDto,
) => {
  return {
    key: emailConfig.id,
    values: {
      'emailConfig.systemNumber': emailConfig.systemNumber,
      type_pl: t(EmailConfigTypeObj[emailConfig.type]),
      'team.name': emailConfig.emailConfigTeams
        ?.map(({ team }) => teamName(team))
        .join(', '),
      'company.shortname': emailConfig.company?.shortname,
      'emailConfig.emails': emailConfig.emails.join(', '),
    },
    isInactive: !emailConfig.active,
  };
};

export const EmailConfigSearch: React.FC<EmailConfigSearchProps> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const columns: GridColumn[] = [
    { header: t(tk.common.sysNumber), property: 'emailConfig.systemNumber' },
    { header: t(tk.administration.type), property: 'type_pl' },
    { header: t(tk.common.company), property: 'company.shortname' },
    { header: t(tk.common.teams), property: 'team.name' },
    { header: t(tk.administration.emails), property: 'emailConfig.emails' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="emailConfig.systemNumber"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.administration.noMailConfigs)}
      onRowClick={props.onRowClick}
      withHistory={true}
      refresh={props.refresh}
      withFilterInColumns={true}
      showExport={true}
    />
  );
};
